import Vue from 'vue'
import axios from 'axios'

const initState = {
  subscriptions: [],
}

export default {
  namespaced: true,

  state: Vue.util.extend({}, initState),

  mutations: {
    setSubscriptions(state, subscriptions) {
      state.subscriptions = subscriptions;
    },
    removeSubscription(state, subscriptionId) {
      state.subscriptions = state.subscriptions.filter(s => s.id !== subscriptionId);
    },
    resetAllSuccess(state) {
      for (let f in state) {
        Vue.set(state, f, initState[f])
      }
    },
  },

  actions: {
    fetchSubscriptions({ commit }, params = {}) {
      return axios.get('agency/subscriptions', { params }).then(res => {
        commit('setSubscriptions', res.data.data);
        return res.data;
      });
    },
    cancelSubscription({ commit }, subscriptionId) {
      return axios.post(`agency/subscriptions/${subscriptionId}/cancel`).then(() => {
        commit('removeSubscription', subscriptionId);
      });
    },
    resetAll({ commit }) {
      commit('resetAllSuccess')
    },
  },

  getters: {
    allSubscriptions(state) {
      return state.subscriptions
    },
  },
}
